import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

import { Router } from '@angular/router';

import { ImageHelper } from './../../../validator/image-helper';
import { SpaceService } from './../../../services/space.service';
import { AuthService } from './../../../services/auth.service';
import { MemberService } from './../../../rest/api/member.service';

@Component({
  selector: 'app-empty-showcase',
  templateUrl: './empty-showcase.component.html',
  styleUrls: ['./empty-showcase.component.scss']
})
export class EmptyShowcaseComponent implements OnInit {
  accessToken: any;
  fileUploadForm: FormGroup;

  uploadObjErr: any;
  uploadMtlErr: any;
  uploadImagesErr: any;

  uploadObjSuccess: any;
  uploadMtlSuccess: any;
  uploadImagesSuccess: any;

  objStatusErr: any;
  mtlStatusErr: any;
  imageStatusErr: any;

  spaceData: any;

  objUploadResponse = { status: '', message: '', filePath: '' };
  mtlUploadResponse = { status: '', message: '', filePath: '' };
  imagesUploadResponse = { status: '', message: '', filePath: '' };

  isSubmitting = false;
  isSubmitted = false;

  errors = [];
  errorMessage: any;
  constructor(
    public router: Router,
    public fb: FormBuilder,
    public spaceService: SpaceService,
    public authService: AuthService,
    public memberService: MemberService
  ) {
    this.accessToken = `Bearer ${this.authService.getAccessToken()}`;
  }

  ngOnInit() {
    this.spaceService.spaceDataSubscription.subscribe(response => {
      if (Object.keys(response).length === 0 && response.constructor === Object) {
        this.router.navigate(['/member']);
      }
      if (response) {
        this.spaceData = response;
        this.initFileUploadForm();
        this.updateSuccessStatus();
      }
    });

    this.spaceService.spaceErrorDataSubscription.subscribe((error: any) => {
      this.handleErrors(error);
    });

  }

  initFileUploadForm() {
    this.fileUploadForm = this.fb.group({
      objFile: [this.spaceData.media && this.spaceData.media.obj && this.spaceData.media.obj !== null
        ? this.spaceData.media.obj : '', [Validators.required]],
      mtlFile: [this.spaceData.media && this.spaceData.media.mtl && this.spaceData.media.mtl !== null
        ? this.spaceData.media.mtl : '', [Validators.required]],
      zipFile: [this.spaceData.media && this.spaceData.media.zip && this.spaceData.media.zip !== null
        ? this.spaceData.media.zip : '', [Validators.required]]
    });
  }

  updateSuccessStatus() {
    if (this.spaceData.media && this.spaceData.media.obj && this.spaceData.media.obj !== null) {
      this.uploadObjSuccess = true;
    }
    if (this.spaceData.media && this.spaceData.media.mtl && this.spaceData.media.mtl !== null) {
      this.uploadMtlSuccess = true;
    }
    if (this.spaceData.media && this.spaceData.media.zip && this.spaceData.media.zip !== null) {
      this.uploadImagesSuccess = true;
    }
  }

  onFileChangeObj(event) {
    this.uploadObjErr = undefined;
    if (event.target.files.length === 0) { return; }
    const selectedFile = event.target.files[0] as File;

    const name = selectedFile && selectedFile.name;
    const fileExtension = name.split('.').pop();
    if (ImageHelper.isObjSizeExceeded(selectedFile.size)) {
      event.target.value = null;
      this.uploadObjErr = 'Please upload file less than 500 MB.';
      return;
    }

    if (fileExtension !== 'obj') {
      event.target.value = null;
      this.uploadObjErr = 'Please upload valid file type (i.e obj).';
      return;
    }

    this.objStatusErr = undefined;
    this.uploadObjSuccess = undefined;

    this.fileUploadForm.get('objFile').setValue(selectedFile);

    const formData = new FormData();
    formData.append('file', selectedFile);
    formData.append('uuid', this.spaceData.uuid);
    formData.append('type', 'obj');
    this.spaceService.upload(formData, this.accessToken).subscribe(
      (res) =>  {
        this.objUploadResponse = res;
        if (res && res.success) {
          this.uploadObjSuccess = true;
        }
      },
      (err) => this.uploadObjErr = err.message
    );
  }

  onFileChangeMtl(event) {
    this.uploadMtlErr = undefined;
    if (event.target.files.length === 0) { return; }
    const selectedFile = event.target.files[0] as File;

    const name = selectedFile && selectedFile.name;
    const fileExtension = name.split('.').pop();
    if (ImageHelper.isMtlSizeExceeded(selectedFile.size)) {
      event.target.value = null;
      this.uploadMtlErr = 'Please upload file less than 100 MB.';
      return;
    }

    if (fileExtension !== 'mtl') {
      event.target.value = null;
      this.uploadMtlErr = 'Please upload valid file type (i.e mtl).';
      return;
    }

    this.mtlStatusErr = undefined;
    this.uploadMtlSuccess = undefined;

    this.fileUploadForm.get('mtlFile').setValue(selectedFile);

    const formData = new FormData();
    formData.append('file', selectedFile);
    formData.append('uuid', this.spaceData.uuid);
    formData.append('type', 'mtl');
    this.spaceService.upload(formData, this.accessToken).subscribe(
      (res) => {
        this.mtlUploadResponse = res;
        if (res && res.success) {
          this.uploadMtlSuccess = true;
        }
      },
      (err) => this.uploadMtlErr = err.message
    );
  }

  onFileChangeImages(event) {
    this.uploadImagesErr = undefined;
    if (event.target.files.length === 0) { return; }
    const selectedFile = event.target.files[0] as File;

    const name = selectedFile && selectedFile.name;
    const fileExtension = name.split('.').pop();
    if (ImageHelper.isZipImageSizeExceeded(selectedFile.size)) {
      event.target.value = null;
      this.uploadImagesErr = 'Please upload file less than 1 GB.';
      return;
    }

    if (fileExtension !== 'zip') {
      event.target.value = null;
      this.uploadImagesErr = 'Please upload valid file type (i.e zip).';
      return;
    }

    this.imageStatusErr = undefined;
    this.uploadImagesSuccess = undefined;

    this.fileUploadForm.get('zipFile').setValue(selectedFile);

    const formData = new FormData();
    formData.append('file', selectedFile);
    formData.append('uuid', this.spaceData.uuid);
    formData.append('type', 'zip');
    this.spaceService.upload(formData, this.accessToken).subscribe(
      (res) => {
        this.imagesUploadResponse = res;
        if (res && res.success) {
          this.uploadImagesSuccess = true;
        }
      },
      (err) => this.uploadImagesErr = err.message
    );
  }

  submitFiles(value) {
    if (!this.fileUploadForm.valid) {
      this.isSubmitting = true;
      return;
    }
    if (this.isSubmitted) {
      return;
    }
    this.isSubmitted = true;
    this.resetErrors();
    this.memberService.validateSpaceObject({
      Authorization: this.accessToken,
      id: this.spaceData.uuid
    }).subscribe(
      (res) => {
        this.router.navigate([`/member/spaces/${this.spaceData.uuid}/showcase`]);
      },
      (err) => {
        this.isSubmitting = false;
        this.isSubmitted = false;
        if (err.error && err.error.errors && err.error.errors[0]) {
          const error = err.error.errors[0];
          this.handleErrors(error);
        }
      }
    );
  }

  handleErrors(error) {
    // Handle status
    if (error && error.status === 'obj') {
      this.objStatusErr = true;
    } else if (error && error.status === 'mtl') {
      this.mtlStatusErr = true;
    } else if (error && error.status === 'zip') {
      this.imageStatusErr = true;
    }
    // Handle Errors
    if (error.status && error.status === 'new') {
      this.errors = [];
      this.errorMessage = undefined;
    } else if (error.detail) {
      if (Array.isArray(error.detail)) {
        this.errors = error.detail;
      } else {
        this.errorMessage = error.detail;
      }
    } else {
      this.errorMessage = error.message ? error.message : 'Error while uploading files. Please verify your files.';
    }
  }

  resetErrors() {
    this.uploadImagesErr = undefined;
    this.uploadMtlErr = undefined;
    this.uploadImagesErr = undefined;
    this.errorMessage = undefined;

    this.objStatusErr = undefined;
    this.mtlStatusErr = undefined;
    this.imageStatusErr = undefined;

    this.errors = [];
  }

}
